import { SettingsSearchProvider } from './SettingsSearchContext'

type SettingsShellProps = {
    children: React.ReactNode
}

export const SettingsShell = ({ children }: SettingsShellProps) => (
    <SettingsSearchProvider>
        <div className="min-w-0 flex-1">{children}</div>
    </SettingsSearchProvider>
)
